import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Add, Delete, DeleteOutline, Edit } from "@mui/icons-material";
import axios from "axios";
import DeleteModal from "../../components/Modals/DeleteModal";
import { toast } from "react-toastify";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { TextField, Button } from "@mui/material";

export default function OnSitePrices() {
  const { id } = useParams();

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // services data table

  const [servicesPer, setServicesPer] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const getServices = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/price-per-visits/category/${id}`,
        { headers }
      );
      console.log(response.data.data);
      setServicesPer(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.3,
      minWidth: 40,
    },
    {
      field: "group",
      headerName: "Group",
      flex: 0.7,
      minWidth: 80,
    },
    {
      field: "service",
      headerName: "Service Name",
      flex: 1.2,
      minWidth: 120,
    },
    {
      field: "price",
      headerName: "Price",
      flex: 0.7,
      minWidth: 80,
    },
    {
      field: "update",
      headerName: "Last Update",
      flex: 0.7,
      minWidth: 80,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.5,
      minWidth: 60,
      renderCell: (params) => {
        const service = params.row.rawData;
        const handleEdit = (event) => {
          event.stopPropagation();
          handleEditServiceGroup(service);
        };
        const handleDelete = (event) => {
          event.stopPropagation();
          confirmDelete(params.row.id);
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={handleEdit}
              color="default"
              style={{ width: "30%" }}
              aria-label="edit"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={handleDelete}
              color="error"
              style={{ width: "30%" }}
              aria-label="delete"
            >
              <DeleteOutline />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  const filteredRows = servicesPer
    ?.filter((service) => {
      const matchesSearch =
        service.service?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        service.group?.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesSearch;
    })
    ?.map((service) => ({
      id: service.id,
      group: service.group,
      service: service.service,
      price: service.price || "",
      update: formatDate(service.updated_at) || "None",
      Actions: "",
      rawData: service,
    }));

  // add & update

  const [show, setShow] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [services, setServices] = useState([{ service: "", price: "" }]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  // 🔹 Handle Modal Open
  const handleShow = () => {
    setGroupName("");
    setServices([{ service: "", price: "" }]);
    setIsEditing(false);
    setEditId(null);
    setShow(true);
  };

  // 🔹 Handle Modal Close
  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditId(null);
    setGroupName("");
    setServices([{ service: "", price: "" }]);
  };

  // 🔹 Handle Edit (Prefill)
  const handleEditServiceGroup = (service) => {
    console.log(service);

    setGroupName(service.group || "");
    setServices([
      { service: service.service || "", price: service.price || "" },
    ]);
    setIsEditing(true);
    setEditId(service.id);
    setShow(true);
  };

  // Add new service input row
  const handleAddService = () => {
    setServices([...services, { service: "", price: "" }]);
  };

  // Remove service input row
  const handleRemoveService = (index) => {
    const updated = services.filter((_, i) => i !== index);
    setServices(updated);
  };

  // Update service name/price value
  const handleChange = (index, field, value) => {
    const updated = [...services];
    updated[index][field] = value;
    setServices(updated);
  };

  // Submit create/update
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("category_id", id);

    if (isEditing) {
      // only one service edit
      formData.append("group", groupName);
      formData.append("service", services[0].service);
      formData.append("price", services[0].price);
      formData.append("_method", "PATCH");
    } else {
      // create multiple new services
      services.forEach((s, i) => {
        formData.append(`services[${i}][group]`, groupName);
        formData.append(`services[${i}][service]`, s.service);
        formData.append(`services[${i}][price]`, s.price);
      });
    }

    const url = isEditing
      ? `${newBaseUrl}/api/portal/price-per-visits/${editId}`
      : `${newBaseUrl}/api/portal/price-per-visits/bulk`;

    try {
      await axios.post(url, formData, {
        headers: { Authorization: "Bearer " + token },
      });

      toast.success(
        isEditing
          ? "Service Updated Successfully"
          : "Service Group Created Successfully",
        { autoClose: 3000 }
      );

      handleClose();
      getServices && getServices();
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong", {
        autoClose: 3000,
      });
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // delete service

  const [serviceId, setServiceId] = useState(null);

  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = (id) => {
    setShowDelete(true);
    setServiceId(id);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setServiceId(null);
  };

  const deleteService = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/price-per-visits/${serviceId}`,
        {
          headers,
        }
      );
      toast.warning("Service Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getServices();
    } catch (error) {
      toast.error("Failed To Delete This Service.");
      console.log(error.message);
    }
  };

  useEffect(() => {
    getServices();
  }, [id]);

  return (
    <>
      {/* add & update modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Edit Service Group" : "Add Service Group"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            {/* Group Name */}
            <TextField
              className="w-100 mb-4"
              label="Group Name"
              variant="outlined"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              required
            />
            {/* Services List */}
            {services.map((service, index) => (
              <div key={index} className="row align-items-center mb-3">
                <div className="col-6">
                  <TextField
                    className="w-100"
                    label="Service Name"
                    variant="outlined"
                    value={service.service}
                    onChange={(e) =>
                      handleChange(index, "service", e.target.value)
                    }
                    required
                  />
                </div>
                <div className="col-6">
                  <TextField
                    className="w-100"
                    label="Service Price"
                    variant="outlined"
                    type="number"
                    value={service.price}
                    onChange={(e) =>
                      handleChange(index, "price", e.target.value)
                    }
                    required
                  />
                </div>
                {!isEditing ? (
                  <div className=" text-end">
                    {index === services.length - 1 ? (
                      <Button
                        variant="contained"
                        color="black"
                        onClick={handleAddService}
                        className="mt-2"
                      >
                        <Add fontSize="small" /> Add Other Service
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleRemoveService(index)}
                        className="mt-2"
                      >
                        <Delete /> Delete
                      </Button>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ))}
            {/* Footer */}
            <div className="categories_foterAddModel mt-4">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* delete service  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this service?"}
        deleteFunction={deleteService}
      />
      {/* servicesPer data  */}
      <div className="m-4">
        {/* servicesPer head  */}
        <div className="notifications-display d-flex justify-content-between align-items-center">
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">On-Site Pricing</p>
          <button
            onClick={handleShow}
            className="btn border border-1 text-muted p-2"
          >
            <i className="fa-solid fa-plus fw-light mx-1"></i>
            Add Pricing
          </button>
        </div>
        {/* servicesPer search  */}
        <div className="notif-search d-flex justify-content-center justify-content-md-start align-items-center my-3">
          {/* text search  */}
          <FormControl sx={{ width: "60ch" }} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Search for group , service...
            </InputLabel>
            <OutlinedInput
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id="outlined-adornment-password"
              type={"text"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">{<SearchIcon />}</IconButton>
                </InputAdornment>
              }
              label="Search for group , service..."
            />
          </FormControl>
        </div>
        {/* servicesPer table  */}
        <div>
          {filteredRows && filteredRows.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Services Yet. All your Services will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
